import type { DocumentIcon } from "@elaso/shared/types/db";
import { File as FileIcon, FileSpreadsheet, Globe } from "lucide-react";

export const DOCUMENT_ICON_OPTIONS: {
	value: DocumentIcon;
	label: string;
	icon: React.ReactNode;
}[] = [
	{ value: "file", label: "File", icon: <FileIcon className="size-4" /> },
	{
		value: "google_doc",
		label: "Google Doc",
		icon: (
			<svg
				aria-label="Google Doc"
				className="size-4"
				fill="currentColor"
				role="img"
				viewBox="0 0 24 24"
			>
				<title>Google Doc</title>
				<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 2l5 5h-5V4zM8 12h8v2H8v-2zm0 4h8v2H8v-2zm0-8h3v2H8V8z" />
			</svg>
		),
	},
	{
		value: "google_sheet",
		label: "Google Sheet",
		icon: <FileSpreadsheet className="size-4" />,
	},
	{
		value: "notion",
		label: "Notion",
		icon: (
			<svg
				aria-label="Notion"
				className="size-4"
				fill="currentColor"
				role="img"
				viewBox="0 0 24 24"
			>
				<title>Notion</title>
				<path d="M4.459 4.208c.746.606 1.026.56 2.428.466l13.215-.793c.28 0 .047-.28-.046-.326L17.86 1.968c-.42-.326-.98-.7-2.055-.607L3.01 2.295c-.466.046-.56.28-.374.466l1.823 1.447zm.793 3.08v13.904c0 .747.373 1.027 1.214.98l14.523-.84c.841-.046.935-.56.935-1.167V6.354c0-.606-.233-.933-.748-.886l-15.177.887c-.56.047-.747.327-.747.933zm14.337.745c.093.42 0 .84-.42.888l-.7.14v10.264c-.608.327-1.168.514-1.635.514-.748 0-.935-.234-1.495-.933l-4.577-7.186v6.952l1.449.327s0 .84-1.168.84l-3.222.186c-.093-.186 0-.653.327-.746l.84-.233V9.854L7.822 9.76c-.094-.42.14-1.026.793-1.073l3.456-.233 4.764 7.279v-6.44l-1.215-.14c-.093-.514.28-.886.747-.933l3.222-.186zM2.1 1.155l13.215-.98c1.635-.14 2.055-.047 3.082.7l4.25 2.986c.7.513.933.653.933 1.213v16.378c0 1.026-.373 1.634-1.68 1.726l-15.458.934c-.98.047-1.448-.093-1.962-.747l-3.129-4.06c-.56-.747-.793-1.306-.793-1.96V2.948c0-.84.374-1.54 1.542-1.793z" />
			</svg>
		),
	},
	{
		value: "pdf",
		label: "PDF",
		icon: (
			<svg
				aria-label="PDF"
				className="size-4"
				fill="currentColor"
				role="img"
				viewBox="0 0 24 24"
			>
				<title>PDF</title>
				<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 2l5 5h-5V4zM8.5 13.5c0-.83.67-1.5 1.5-1.5h.5v3h-.5c-.83 0-1.5-.67-1.5-1.5zm4.5 0c0-.83.67-1.5 1.5-1.5h.5v3h-.5c-.83 0-1.5-.67-1.5-1.5z" />
			</svg>
		),
	},
	{ value: "website", label: "Website", icon: <Globe className="size-4" /> },
];

export const getDocumentIcon = (icon: DocumentIcon) => {
	const option = DOCUMENT_ICON_OPTIONS.find((opt) => opt.value === icon);
	return option?.icon ?? <FileIcon className="size-4" />;
};
